export const RootPaths = {
  HOME: "/home",
  WELCOME: "/welcome",
  LINK: "/link",
  APP_V2: "/v2",
  APP_V2_HOME: "/home-v2",
  NOT_FOUND: "/not-found",
  ERROR: "/error",
};

/**
 * Split these up and move these paths into the projects that manage these paths.
 */
export const DeprecatedGlobalAppV1Paths = {
  MY_SHIFTS: `${RootPaths.HOME}/myShifts`,
  OPEN_SHIFTS: `${RootPaths.HOME}/openShifts`,
  RATINGS: `${RootPaths.HOME}/ratings`,
  RATINGS_BADGES: `${RootPaths.HOME}/ratings/badges`,
  RATINGS_A_TEAM: `${RootPaths.HOME}/ratings/a-team`,
  ACCOUNT: `${RootPaths.HOME}/account`,
  CHAT: `${RootPaths.HOME}/account/chat/:facilityId`,
  SUPPORT: `${RootPaths.HOME}/account/support`,
  ADDRESS: `${RootPaths.HOME}/account/address`,
  PAYROLL: `${RootPaths.HOME}/account/payroll`,
  PROFILE: `${RootPaths.HOME}/account/profile`,
  PROFILE_CONTRACT: `${RootPaths.HOME}/account/profile/contract`,
  SAVINGS: `${RootPaths.HOME}/account/savings`,
  SAVINGS_CONFIGURATION_GOALS: `${RootPaths.HOME}/account/savings/configuration/goals`,
  SAVINGS_CONFIGURATION_ALLOCATION: `${RootPaths.HOME}/account/savings/configuration/allocation`,
  SAVINGS_BOOK_CALL: `${RootPaths.HOME}/account/savings/book-call`,
  MY_SHIFT_DETAIL: `${RootPaths.HOME}/myShifts/:shiftId`,
  UNVERIFIED_SHIFTS: `${RootPaths.HOME}/myShifts/unverifiedShifts`,
  SUCCESS_ONBOARDING: `${RootPaths.HOME}/alreadyOnboarded`,
  PAYMENT_SERVICE_ONBOARDING: `${RootPaths.HOME}/onboardingPayments`,
  UPDATED_CONTRACTOR_AGREEMENT: `${RootPaths.HOME}/updatedContractorAgreement`,
  FACILITY_DETAIL: `${RootPaths.HOME}/facility/:facilityId`,
  NEED_HELP: `${RootPaths.HOME}/account/needhelp`,
  HELP_DETAILS: `${RootPaths.HOME}/account/needhelp/details`,
  UPDATE_PROFILE: `${RootPaths.HOME}/updateProfile`,
  DELETE_DATA: `${RootPaths.HOME}/deleteData`,
  LICENSE_MANAGER: `${RootPaths.HOME}/account/licenses`,
  LICENSE_MANAGER_ADD: `${RootPaths.HOME}/account/licenses/add`,
  LICENSE_DETAILS: `${RootPaths.HOME}/account/licenses/:licenseId/details`,
  ADD_LICENSE: `${RootPaths.HOME}/account/licenses/add`,
  LICENSE_RECIPROCITY: `${RootPaths.HOME}/account/license-reciprocity`,
  COLLEAGUE_LIST: `${RootPaths.HOME}/colleagueList`,
  RATE_NEGOTIATIONS: `${RootPaths.HOME}/rate-negotiations`,
  FRIENDS_LIST: `${RootPaths.HOME}/account/friends`,
  SETUP_STRIPE: `${RootPaths.HOME}/stripeSetUp`,
  PROFESSIONAL_REFERENCE: `${RootPaths.HOME}/professional-references`,
  NOTIFICATION_CENTER: `${RootPaths.HOME}/notification-center`,
  CAREER_AGENT: `${RootPaths.HOME}/careerAgent`,
  WORKPLACE_REFERRALS: `${RootPaths.HOME}/account/workplace-referrals`,
  RATE_NEGOTIATION_TOOL: `${RootPaths.HOME}/rate-negotiation-tool/:shiftId`,
  SHIFT_FEEDBACK_RESOLVER: `${RootPaths.HOME}/shift-feedback-resolver`,
};
